import React from 'react';
import PropTypes from 'prop-types';

import Text from '../../Text/Text';
import CustomSelect from '../../Select/CustomSelect';

const CarSelectors = ({
  label, options, value,
  isDisabled, onChange, isClearable, maxSelectedValue
}) => (
  <>
    <Text
      text={label}
    />
    <CustomSelect
      options={options}
      value={value}
      isDisabled={isDisabled}
      isMulti
      isSearchable
      onChange={onChange}
      isClearable={isClearable}
      maxSelectedValue={maxSelectedValue}
      closeMenuOnSelect={false}
    />
  </>
);

CarSelectors.propTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  value: PropTypes.arrayOf(PropTypes.shape({})),
  isDisabled: PropTypes.bool,
  isClearable: PropTypes.bool,
  onChange: PropTypes.func,
  maxSelectedValue: PropTypes.number,
};

CarSelectors.defaultProps = {
  label: '',
  options: [],
  value: [],
  isDisabled: false,
  isClearable: false,
  onChange: () => {},
  maxSelectedValue: 10,
};

export default CarSelectors;
